export default interface DataSetOperators {
  Top?: number;
  Skip?: number;
  ProjectId?: number;
  SearchProperty?: string;
  SearchType?: SearchType;
  SearchValue?: string;
  SortBy?: string;
  SortDirection?: SortDirection;
  DocumentId?: number;
}

export enum SearchType {
  EqualTo = 'EqualTo',
  NotEqualTo = 'NotEqualTo',
  Contains = 'Contains'
}

export enum SortDirection {
  Asc = 'Asc',
  Desc = 'Desc',
}
